
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#4D4D4D"}},[_c('path',{attrs:{"d":"M1.337 6.413c.395 0 .715.32.715.716v4.892c0 .906.738 1.649 1.65 1.649h11.595c.906 0 1.649-.738 1.649-1.65V7.21a.716.716 0 011.431 0v4.81a3.082 3.082 0 01-3.08 3.08H3.7a3.082 3.082 0 01-3.08-3.08V7.13c0-.395.32-.716.716-.716z"}}),_c('path',{attrs:{"d":"M9.384.898c.395 0 .716.32.716.716v8.621a.715.715 0 11-1.432 0V1.614c0-.395.32-.716.716-.716z"}}),_c('path',{attrs:{"d":"M12.4 7.478c.279.28.279.732 0 1.012l-2.09 2.088a1.304 1.304 0 01-1.84 0L6.471 8.58a.716.716 0 111.012-1.012L9.39 9.475l1.997-1.997a.716.716 0 011.012 0z"}})])])
          )
        }
      }
    